import React from "react";
// import editIcon from "../../assets/images/icons/ic_edit.svg";
// import { Link } from "react-router-dom";
import * as Styled from "./Style";
// import * as GlobalStyle from "../../CSSStyles";

const Address = (props) => {
  return (
    <div title="Select this address">
      <Styled.EditToggle
        type="radio"
        id={props.addressType + "_editAddressToggle_" + props.id}
        // id={"editAddressToggle_" + props.id}
        className="editAddressToggle edit hidden"
        name={props.addressType + "_editAddressToggle"}
        // name={"editAddressToggle"}
        onChange={props.editAddressToggle}
        checked={
          props.addressType == "delivery"
            ? props.showDeliveryEditAddressFormID == props.id
              ? true
              : false
            : props.addressType == "billing"
            ? props.showBillingEditAddressFormID == props.id
              ? true
              : false
            : false
        }
        readOnly
        tabIndex="-1"
      ></Styled.EditToggle>
      <Styled.AddressStyle className="address-option">
        {/* {props.addressType == "delivery" ? (
          props.showDeliveryEditAddressFormID == props.id ? (
            <h1>
              Delivery {props.showDeliveryEditAddressFormID} - {props.id}
            </h1>
          ) : (
            <h1>
              Delivery {props.showDeliveryEditAddressFormID} - {props.id}
            </h1>
          )
        ) : props.addressType == "billing" ? (
          props.showBillingEditAddressFormID == props.id ? (
            <h1>
              Billing {props.showBillingEditAddressFormID} - {props.id}
            </h1>
          ) : (
            <h1>
              Billing {props.showBillingEditAddressFormID} - {props.id}
            </h1>
          )
        ) : (
          ""
        )} */}
        <input
          type="radio"
          id={props.addressType + "-" + props.id}
          value={props.id}
          name={props.addressType}
          onClick={!props.selectedAddress? props.updateSelectedAddress: null}
          tabIndex="-1"
          // defaultChecked={
          //   props.addressType == "delivery"
          //     ? props.defaultDeliveryAddressID == props.id
          //     : props.defaultBillingAddressID == props.id
          // }
          defaultChecked={props.selectedAddress}
        />
        <label htmlFor={props.addressType + "-" + props.id}>
          <div>
            {props.isPrimary ? (
              <p className="default-label">Default address</p>
            ) : (
              ""
            )}
            <p className="addressName">
              {props.firstName + " " + props.lastName}
            </p>
            <p className="addressLocation">
              {props.addressLine1}
              {props.streetAddress ? ", " + props.streetAddress : ""}
              {/* {", " + props.city}
              {", " + props.postCode}
              {", " + props.state}
              {", " + props.country} */}
            </p>
            <input
              type="checkbox"
              id={"mobile-action-toggle-" + props.addressType + "-" + props.id}
              className="mobile-action-toggle-checkbox"
              tabIndex="-1"
            />
            <label
              className="mobile-action-toggle-btn"
              htmlFor={
                "mobile-action-toggle-" + props.addressType + "-" + props.id
              }
            >
              Toggle Address Options
            </label>
            <Styled.AddressActionStyle className="action-wrapper">
              <button
                type="button"
                className="action delete"
                title={"Delete address"}
                onClick={props.isDeleteAddressModalOpen}
                // onClick={(event) => props.isDeleteAddressModalOpen(props.id)}
              >
                Delete {props.addressType} address
              </button>
              {/* <button
                type="button"
                className="edit"
                // title={"Edit " + props.addressType + " address"}
                // onClick={props.isEditAddressModalOpen}
              >
                Edit {props.addressType} address
              </button> */}
              {/* <input type="checkbox" id="editAddressToggle"></input> */}

              {/* <button
                type="button"
                className="action edit"
                title={"Edit " + props.addressType + " address"}
              > */}
              <label
                htmlFor={props.addressType + "_editAddressToggle_" + props.id}
                className="action edit"
                title={"Edit address"}
                role="button"
                tabIndex="0"
                // onKeyDown={props.handleKeyDown}
                onKeyDown={(e) => {
                  e.key === "Enter" && props.editAddressToggle();
                }}
                // htmlFor={"editAddressToggle_" + props.id}
              >
                {" "}
                Edit {props.addressType} address
                {/* <img src={editIcon} /> */}&nbsp;
              </label>
              {/* </button> */}
            </Styled.AddressActionStyle>
          </div>
        </label>
      </Styled.AddressStyle>
      {props.children}
    </div>
  );
};

export default Address;
